<template>
  <div>
    <Modal
      v-model="show"
      :title="$t('info')"
      :mask-closable="false"
      width="800"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :label-width="120" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <TabPane :label="$t('Langue.zn')" name="1">
              <div class="tabs_item">
                <FormItem class="item_input" :label="$t('infoPush.name')">
                  <span>{{form['zh-cn_cname']}}</span>
                </FormItem>
                <FormItem :label="$t('infoPush.content')">
                  <span>{{form['zh-cn_cdesc']}}</span>
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.tw')" name="2">
              <div class="tabs_item">
                <FormItem class="item_input" :label="$t('infoPush.name')">
                  <span>{{form['zh-cn_cdesc']}}</span>
                </FormItem>
                <FormItem :label="$t('infoPush.content')">
                  <span>{{form['zh-tw_cdesc']}}</span>
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.en')" name="3">
              <div class="tabs_item">
                <FormItem class="item_input" :label="$t('infoPush.name')">
                  <span>{{form.en_cname}}</span>
                </FormItem>
                <FormItem :label="$t('infoPush.content')">
                  <span>{{form.en_cdesc}}</span>
                </FormItem>
              </div>
            </TabPane>
          </Tabs>
          <div class="item">
            <FormItem :label="$t('Info.url')">
              <span>{{form.url_link}}</span>
            </FormItem>
            <FormItem :label="$t('sort')">
              <span>{{form.sort_id}}</span>
            </FormItem>
            <FormItem :label="$t('status')">
              <span>{{form.status == 0 ? $t('close'):$t('enabled')}}</span>
            </FormItem>
          </div>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{$t('back')}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,

  },
  data () {
    return {
      tabs: '1',
      switch1: false,
      form: {
        info_item_id: null,
        sort_id: null,
        en_cname: "",
        en_cdesc: "",
        en_image: "",
        "zh-cn_cname": "",
        "zh-cn_cdesc": "",
        "zh-cn_image": "",
        "zh-tw_cdesc": "",
        "zh-tw_cname": "",
        "zh-tw_image": "",
        url_link: '',
        status: "0",
      },
      show: this.modal
    }

  },
  created () {
    this.info()
  },
  mounted () {

  },
  methods: {
    info () {
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'edu-info-push/before-upd',
          { info_item_id: this.itemObj.info_item_id },
          (success, data, error) => {
            this.$base.hideLoading();
            if (!success) return this.$base.alertErr(error.errmsg);
            this.form = data.info_item
            this.form.sort_id = this.form.sort_id * 1
          }
        );
      }
    },
    cancel () {
      this.$emit('cancel');
    },
    ontabs (item) {
      this.tabs = item
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .ivu-tabs .ivu-tabs-tabpane {
    margin-top: 40px;
  }
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 0 0 20px 10%;
  }
  .tabs_item {
    width: 80%;
    margin: 20px 0 0 10%;
    .item_input {
      width: 100%;
      padding-right: 10px;
    }
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .demo-upload-list {
    display: inline-block;
    width: 150px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-upload-drag {
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/baseMtagItem/module/baseMtagItem_info.vue